import React, { ReactElement } from "react";
import { Icon, Spinner, SpinnerSize, Stack, ensure, ActionStatus } from "sprint-common-web";

export const renderActionStatus = <T extends { processStatus: ActionStatus }>(item?: T): ReactElement | null => {
    ensure(item);
    const status = item["processStatus"];

    const indicator = (() => {
        switch (status) {
            case ActionStatus.WaitingForConfirmation: {
                return <></>;
            }

            case ActionStatus.InProgress: {
                return <Spinner size={SpinnerSize.small} />;
            }

            case ActionStatus.Completed: {
                return <Icon iconName="Accept" />;
            }

            case ActionStatus.Failed: {
                return <Icon iconName="Cancel" />;
            }
        }
    })();

    return <Stack horizontalAlign="start">{indicator}</Stack>;
};
